<div>
  <mat-form-field appearance="fill">
    <mat-label>Camera</mat-label>
    <mat-select [(value)]="selectedCamera" (selectionChange)="onCameraChange($event)">
      @for (camera of cameras; track camera) {
        <mat-option [value]="camera.deviceId">
          {{ camera.label }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Microphone</mat-label>
    <mat-select [(value)]="selectedMicrophone" (selectionChange)="onMicrophoneChange($event)">
      @for (microphone of microphones; track microphone) {
        <mat-option [value]="microphone.deviceId">
          {{ microphone.label }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <button (click)="fetchCameras()" mat-mini-fab color="primary">
    <mat-icon>refresh</mat-icon>
  </button>
</div>
